var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle-btn-container",class:{ alive:_vm.isAlive }},[_c('div',{staticClass:"circle-btn",class:{ clicked:_vm.isClicked },on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }